module.exports = __webpack_public_path__ + "img/checkedMove.07de9088.png";